
import { Vue, Component } from 'vue-property-decorator'
import util from '@/utils/busi/util'
import DetailView from './detailview.vue'

@Component({
  name: 'detail',
  components: {
    'detail-view': DetailView
  }
})

export default class OrderCenterDetail extends Vue {
  private params = util.getRouterParams()

  private onBack () {
    this.$router.push({
      name: 'agentSettlement'
    })
  }
}
